import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

import SubmissionsView from "./views/submissions-view/SubmissionsView";
import AssetsView from "./views/assets-view/AssetsView";
import ReportView from "./views/report-view/ReportView";
import Header from "./components/header/Header";
import CartSidebar from "./components/cart-sidebar/CartSidebar";
import SavedSearchesSidebar from "./components/saved-searches-sidebar/SavedSearchesSidebar";
import NavBar from "./components/nav-bar/NavBar";
import NuxeoConnect from "./components/nuxeo-connect/NuxeoConnect";
import ConfigurationManager from "./configuration/ConfigurationManager";

import "./App.css";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentUser: null,
      showCart: false,
      showSavedSearches: false,
      cartItemsCount: 0,
      reportItems: [],
      showReportView: false,
      currentPage: "",
    };

    ConfigurationManager.environment = {
      REACT_APP_NUXEO_HOST: process.env.REACT_APP_NUXEO_HOST,
      REACT_APP_NUXEO_PORT: process.env.REACT_APP_NUXEO_PORT,
      REACT_APP_WBCP_HOST: process.env.REACT_APP_WBCP_HOST,
      REACT_APP_WBCP_PORT: process.env.REACT_APP_WBCP_PORT,
    };

    this._handleConnect = this._handleConnect.bind(this);
    this._handleShowCartClick = this._handleShowCartClick.bind(this);
    this._handleAddToCart = this._handleAddToCart.bind(this);
    this._handleCartItemDeleted = this._handleCartItemDeleted.bind(this);
    this._handleCartRunReport = this._handleCartRunReport.bind(this);
    this._handleUpdateCartItemCount = this._handleUpdateCartItemCount.bind(
      this
    );
    this._handleReportBackClick = this._handleReportBackClick.bind(this);
    this._handleCloseCart = this._handleCloseCart.bind(this);
    this._handleCartItemClear = this._handleCartItemClear.bind(this);
  }

  get currentUser() {
    return this.state.currentUser;
  }

  set currentUser(currentUser) {
    this.setState({ currentUser: currentUser });
  }

  get showCart() {
    return this.state.showCart;
  }

  set showCart(showCart) {
    this.setState({ showCart: showCart });
  }

  get showReportView() {
    return this.state.showReportView;
  }

  set showReportView(showReportView) {
    this.setState({ showReportView: showReportView });
  }

  get showSavedSearches() {
    return this.state.showSavedSearches;
  }

  set showSavedSearches(showSavedSearches) {
    this.setState({ showSavedSearches: showSavedSearches });
  }

  get cartItemsCount() {
    return this.state.cartItemsCount;
  }

  set cartItemsCount(cartItemsCount) {
    this.setState({ cartItemsCount: cartItemsCount });
  }

  get currentPage() {
    return this.state.currentPage;
  }

  set currentPage(currentPage) {
    this.setState({ currentPage: currentPage });
  }

  _handleConnect(event) {
    this.currentUser = event.detail.user;
  }

  _handleShowCartClick(event) {
    this.showCart = !this.showCart;
  }

  _handleCloseCart(event) {
    this.currentPage = event.detail.view;
    this.showCart = false;
  }

  _handleAddToCart(event) {
    const currentItems = this._cartSidebar.items;
    const newItems = currentItems.concat(event.detail.items);

    this._cartSidebar.items = newItems;
    this.showCart = true;
  }

  _handleUpdateCartItemCount(event) {
    this.cartItemsCount = event.detail.count;
  }

  _handleCartItemDeleted(event) {
    let itemsCount = event.detail.items.length;

    this.showCart &= itemsCount > 0;
    this.cartItemsCount = itemsCount;
  }

  _handleCartRunReport(event) {
    this.setState(
      {
        reportItems: event.detail.items,
        showCart: false,
        showReportView: true,
      },
      () => {
        window.localStorage.setItem(
          "WBCP_VIEW_PATHNAME",
          `${this._router.history.location.pathname}${
            this._router.history.location.search
          }`
        );
        window.history.pushState({}, null, ReportView.getPath());
      }
    );
  }

  _handleReportBackClick(event) {
    this.setState({ showReportView: false }, () => {
      window.history.pushState(
        {},
        null,
        window.localStorage.getItem("WBCP_VIEW_PATHNAME")
      );
    });
  }

  _handleCartItemClear(event) {
    this._cartSidebar.items = []; // Clear the cart item when change page
    this._handleCartItemDeleted(event);
  }

  render() {
    const {
      currentUser,
      showCart,
      cartItemsCount,
      reportItems,
      showSavedSearches,
      showReportView,
      currentPage,
    } = this.state;

    return (
      <div className="app">
        <NuxeoConnect onConnect={this._handleConnect} />
        <Header currentUser={currentUser} />
        <CartSidebar
          ref={(element) => (this._cartSidebar = element)}
          hidden={!showCart}
          view={currentPage}
          onItemDeleted={this._handleCartItemDeleted}
          onRunReport={this._handleCartRunReport}
          onUpdateCartItemCount={this._handleUpdateCartItemCount}
        />
        <SavedSearchesSidebar hidden={!showSavedSearches} />
        {showReportView ? (
          <ReportView
            items={reportItems}
            hidden={!showReportView}
            onBackClick={this._handleReportBackClick}
          />
        ) : null}
        <Router ref={(element) => (this._router = element)}>
          <div className={showReportView ? "hideAsset" : "showAsset"}>
            <NavBar
              onShowCartClick={this._handleShowCartClick}
              cartActive={showCart}
              cartItemsCount={cartItemsCount}
              onCloseCart={this._handleCloseCart}
            />
            <section className="container">
              <div className="content">
                <Route
                  path={SubmissionsView.getPath()}
                  render={() => (
                    <SubmissionsView
                      onAddToCart={this._handleAddToCart}
                      onClearToCart={this._handleCartItemClear}
                    />
                  )}
                />
                <Route
                  path={AssetsView.getPath()}
                  render={() => (
                    <AssetsView
                      onAddToCart={this._handleAddToCart}
                      onClearToCart={this._handleCartItemClear}
                    />
                  )}
                />
              </div>
            </section>
          </div>
        </Router>
      </div>
    );
  }
}

export default App;
